import { apiRegistry } from '../../../common/infra/apiRegistry'
import { filesMem, generateId } from '../mem/filesMem'

apiRegistry.registerPostApi('createFolder', async (request) => {
  const { name, parentId } = request

  // Validate parent exists
  if (parentId && !filesMem[parentId]) {
    throw new Error('Parent folder not found')
  }

  // Check for duplicate names
  const existingFiles = Object.values(filesMem).filter(file => file.parentId === parentId)
  if (existingFiles.some(file => file.name === name)) {
    throw new Error('A file or folder with this name already exists')
  }

  const parentPath = parentId ? filesMem[parentId].path : ''
  const newId = generateId()
  const now = new Date().toISOString()

  const folder = {
    id: newId,
    name,
    type: 'folder' as const,
    modifiedDate: now,
    createdDate: now,
    parentId,
    path: `${parentPath}/${name}`,
    isStarred: false,
    isShared: false
  }

  filesMem[newId] = folder
  return { folder }
})